import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import FormHelperText from "@material-ui/core/FormHelperText";
import InputLabel from "@material-ui/core/InputLabel";
import ListItemText from "@material-ui/core/ListItemText";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import CloseIcon from "@material-ui/icons/Close";
import _ from "lodash";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {
    getFallbackItemPicture,
    getFilteredLineItemName,
    getFilteredLineItemVariant,
    getItemPicture,
    isDeviceProtectionSku,
    isEgiftcardSku,
    isShippingProtectionSku,
    orderHasShippingProtection
} from "../Helpers/OderUtils";
import "../Styles/_CancelOrderItemsWindow.css";
import "../Styles/_OrderPopupWindow.css";
import ConfirmationWindow from "./_ConfirmationWindow";
import DataConflictWindow from "./_DataConflictWindow";
import { Confirmed } from "./_Icon";

let scrolled_into_view = false;

export class CancelOrderItemsWindow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            allocatedCancelItems: [],
            cancelReasonId: null,
            cancelErrorMessage: "",
            itemsAvailableForCancellation: [],
            cancelFinished: false,
            submitErrors: [],
            confirmationWindowOpen: false,
            dataConflictWindowOpen: false
        };
    }

    componentWillMount() {
        scrolled_into_view = false;
    }

    componentDidMount() {
        let itemsAvailableForCancellation = [];

        this.props.order.sub_orders.forEach(so => {
            so.line_items.forEach(line_item => {
                if (
                    line_item.fulfillable_quantity !== 0 &&
                    !isEgiftcardSku(line_item.sku) &&
                    !isShippingProtectionSku(line_item.sku) &&
                    !isDeviceProtectionSku(line_item.sku)
                ) {
                    let lineItem = Object.assign({}, line_item);
                    lineItem.fulfillable_quantity = line_item.fulfillable_quantity;
                    itemsAvailableForCancellation.push(lineItem);
                }
            });
        });

        this.props.order.line_items
            .filter(li => isDeviceProtectionSku(li.sku))
            .forEach(line_item => {
                let refundedDeviceProtectionLineItem = this.props.order.refunded_items
                    ? this.props.order.refunded_items.find(refundedItem => refundedItem.requires_shipping === false && line_item.id === refundedItem.id)
                    : null;
                let lineItem = Object.assign({}, line_item);

                if (refundedDeviceProtectionLineItem) {
                    if (line_item.quantity - refundedDeviceProtectionLineItem.quantity > 0) {
                        lineItem.fulfillable_quantity = line_item.quantity - refundedDeviceProtectionLineItem.quantity;
                        itemsAvailableForCancellation.push(lineItem);
                    }
                } else {
                    lineItem.fulfillable_quantity = line_item.quantity;
                    itemsAvailableForCancellation.push(lineItem);
                }
            });

        this.setState({
            itemsAvailableForCancellation
        });

        this.scrollWindowIntoView();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.loading === false && prevProps.loading === true) {
            if (!this.props.err) {
                this.setState({
                    cancelFinished: true
                });
            } else {
                this.setState({
                    cancelErrorMessage: this.props.currentLanguage.ORDER_PAGE.CANCEL_SECTION.CANCEL_ORDER_ITEMS.ERROR_FAILED
                });
            }
        }

        if (this.props.cancelOrderCalculating === false && prevProps.cancelOrderCalculating === true) {
            if (this.props.cancelOrderCalculatingError) {
                this.setState({
                    cancelErrorMessage: this.props.currentLanguage.ORDER_PAGE.CANCEL_SECTION.CANCEL_ORDER_ITEMS.ERROR_CALCULATION_FAILED
                });
            } else {
                this.resetErrorMessages();
            }
        }

        if (
            (prevProps.cancelOrderCalculating === true &&
                this.props.cancelOrderCalculating === false &&
                this.props.cancelOrderCalculatingError === "conflict") ||
            (prevProps.loading === true && this.props.loading === false && this.props.err === "conflict")
        ) {
            this.setState({
                dataConflictWindowOpen: true
            });
        }

        if (prevProps.open === false && this.props.open === true && this.props.cancelReasons.length === 0 && this.props.cancelReasonsLoading === false) {
            this.props.getCancelReasons();
        }

        if (prevProps.open === false && this.props.open === true) {
            this.resetErrorMessages();
            this.resetCancelReason();
            this.resetCancelItems();
            this.resetCancelFinished();
            this.props.cancelOrderCalculateReset();
            this.resetSubmitErrors();
            scrolled_into_view = false;
        }

        if (JSON.stringify(prevState.allocatedCancelItems) !== JSON.stringify(this.state.allocatedCancelItems)) {
            this.props.cancelOrderCalculate(this.props.match.params.order_id, {
                items: this.state.allocatedCancelItems.map(i => ({ lineItemId: i.line_item_id, quantity: Number(i.quantity) }))
            });
        }
    }

    scrollWindowIntoView() {
        var element = document.getElementById("cancel-order-items-window");

        if (element && !scrolled_into_view) {
            element.scrollIntoView({
                behavior: "auto",
                block: "start",
                inline: "center"
            });
            scrolled_into_view = true;

            this.postMessageToParentWindow();
        }
    }

    postMessageToParentWindow() {
        let data = {
            action: "DIALOG_WINDOW_OPEN"
        };

        window.parent.window.postMessage(JSON.stringify(data), "*");
    }

    resetCancelFinished() {
        this.setState({
            cancelFinished: false
        });
    }

    handleNoClick() {
        if (this.state.cancelFinished) {
            this.props.handleClose();
            this.props.getOrder(this.props.order_id);
        } else {
            this.props.handleClose();
        }
    }

    handleYesClick() {
        this.resetSubmitErrors();
        if (this.getSubmitErrors().length === 0) {
            this.handleOpenConfirmationWindow();
        } else {
            this.updateSubmitErrors();
        }
    }

    updateSubmitErrors() {
        this.setState({
            submitErrors: this.getSubmitErrors()
        });
    }

    handleConfirmCancelOrder() {
        this.resetErrorMessages();
        this.handleCloseConfirmationWindow();
        this.cancelOrder();
    }

    cancelOrder() {
        this.props.cancelOrder(this.props.order_id, {
            items: this.state.allocatedCancelItems.map(i => ({ lineItemId: i.line_item_id, quantity: Number(i.quantity) })),
            reason: this.state.cancelReasonId
        });
    }

    getSubmitErrors() {
        let errors = [];

        if (!this.state.cancelReasonId) {
            errors.push({
                code: "cancel_reason",
                label: this.props.currentLanguage.ORDER_PAGE.CANCEL_SECTION.ERRORS.REASON_REQUIRED
            });
        }

        if (this.state.allocatedCancelItems.length === 0) {
            errors.push({
                code: "cancel_items",
                label: this.props.currentLanguage.ORDER_PAGE.CANCEL_SECTION.CANCEL_ORDER_ITEMS.ERRORS.CANCEL_ITEMS_REQUIRED
            });
        }

        return errors;
    }

    resetSubmitErrors() {
        this.setState({
            submitErrors: []
        });
    }

    resetErrorMessages() {
        this.setState({
            cancelErrorMessage: ""
        });
    }

    handleEnter() {
        this.resetErrorMessages();
    }

    SetBodyScroll() {
        let el = document.getElementById("body");

        if (el.style.overflow === "hidden") {
            el.style.overflow = "initial";
        }
    }

    handleCancelItemRemoveClick(lineItem) {
        let allocatedCancelItem = this.getAllocatedCancelItem(lineItem, this.state.allocatedCancelItems);
        if (allocatedCancelItem) {
            this.handleCancelItemQuantityChangeByValue(lineItem, allocatedCancelItem.quantity - 1);
        }
    }

    handleCancelItemAddClick(lineItem) {
        let allocatedCancelItem = this.getAllocatedCancelItem(lineItem, this.state.allocatedCancelItems);
        if (allocatedCancelItem) {
            this.handleCancelItemQuantityChangeByValue(lineItem, allocatedCancelItem.quantity + 1);
        } else {
            this.handleCancelItemQuantityChangeByValue(lineItem, 1);
        }
    }

    handleCancelItemQuantityChange(lineItem, e) {
        if (!this.props.cancelOrderCalculating && !this.props.loading && !isNaN(e.target.value) && Number(e.target.value) >= 0) {
            let value = Number(e.target.value);

            this.handleCancelItemQuantityChangeByValue(lineItem, value);
        }
    }

    getDeviceProtectionReferenceVariantId(deviceProtectionItem) {
        if (!deviceProtectionItem || !deviceProtectionItem.properties) {
            return null;
        }

        const referenceProperty = deviceProtectionItem.properties.find(property => property.name === "_Extend.ProductId" || property.name === "Reference");

        return referenceProperty && referenceProperty.value ? referenceProperty.value.toString() : null;
    }

    getAllocatedReferenceItemByDeviceProtectionItem(deviceProtectionCancelItem) {
        const protectedVariantId = this.getDeviceProtectionReferenceVariantId(deviceProtectionCancelItem);

        if (!protectedVariantId) {
            return null;
        }

        return this.state.allocatedCancelItems.filter(allocatedCancelItem =>
            this.state.itemsAvailableForCancellation.some(
                itemAvailableForCancellation =>
                    itemAvailableForCancellation.requires_shipping === true &&
                    protectedVariantId === itemAvailableForCancellation.variant_id.toString() &&
                    itemAvailableForCancellation.line_item_id === allocatedCancelItem.line_item_id
            )
        )[0];
    }

    getAvailableCancelItemsByAllocatedCancelItems(allowedCancelItems) {
        return this.state.itemsAvailableForCancellation.filter(itemAvailableForCancellation =>
            allowedCancelItems.some(cancelItem => cancelItem.line_item_id === itemAvailableForCancellation.line_item_id)
        );
    }

    getAllocatedDeviceProtectionCancelItemsByReferenceCancelItem(referenceCancelItem, allocatedCancelItems) {
        let items = this.getAvailableCancelItemsByAllocatedCancelItems(allocatedCancelItems);
        let deviceProtectionCancelItems = items.filter(
            li => isDeviceProtectionSku(li.sku) && this.getDeviceProtectionReferenceVariantId(li) === referenceCancelItem.variant_id.toString()
        );

        return allocatedCancelItems.filter(allocatedCancelItem =>
            deviceProtectionCancelItems.some(deviceProtectionCancelItem => deviceProtectionCancelItem.line_item_id === allocatedCancelItem.line_item_id)
        );
    }

    getAllocatedCancelItem(item, allocatedCancelItems) {
        return allocatedCancelItems.filter(allocatedCancelItem => allocatedCancelItem.line_item_id === item.line_item_id)[0];
    }

    getUpdatedAllocatedCancelItemsAfterRemovingItem(allocatedCancelItems, item) {
        return allocatedCancelItems.filter(allocatedCancelItem => allocatedCancelItem.line_item_id !== item.line_item_id);
    }

    getAvailableForCancellationItem(item) {
        return this.state.itemsAvailableForCancellation.filter(
            itemAvailableForCancellation => itemAvailableForCancellation.line_item_id === item.line_item_id
        )[0];
    }

    getAvailableDeviceProtectionItemsByReferenceItem(referenceItem) {
        return this.state.itemsAvailableForCancellation.filter(
            itemAvailableForCancellation =>
                isDeviceProtectionSku(itemAvailableForCancellation.sku) &&
                this.getDeviceProtectionReferenceVariantId(itemAvailableForCancellation) === referenceItem.variant_id.toString()
        );
    }

    getTotalDeviceProtectionItemsQuantity(referenceItem) {
        let avaliableDeviceProtectionItems = this.getAvailableDeviceProtectionItemsByReferenceItem(referenceItem);

        return avaliableDeviceProtectionItems.reduce((prev, current) => {
            return parseInt(prev) + parseInt(current.fulfillable_quantity);
        }, 0);
    }

    getThresholdQuantity(referenceItem) {
        return referenceItem.fulfillable_quantity - this.getTotalDeviceProtectionItemsQuantity(referenceItem);
    }

    getAllocatedDeviceProtectionCancelItems(referenceItem, allocatedCancelItems) {
        let avaliableDeviceProtectionItems = this.getAvailableDeviceProtectionItemsByReferenceItem(referenceItem);

        return allocatedCancelItems.filter(allocatedCancelItem =>
            avaliableDeviceProtectionItems.some(
                avaliableDeviceProtectionItem => avaliableDeviceProtectionItem.line_item_id === allocatedCancelItem.line_item_id
            )
        );
    }

    getTotalAllocatedDeviceProtectionCancelItemsQuantityAfterUpdate(allocatedDeviceProtectionCancelItems, allocatedDeviceProtectionCancelItem, newQuantity) {
        let allocatedDeviceProtectionItemsCopy = JSON.parse(JSON.stringify(allocatedDeviceProtectionCancelItems));

        allocatedDeviceProtectionItemsCopy.filter(
            allocatedDeviceProtectionItem => allocatedDeviceProtectionItem.line_item_id === allocatedDeviceProtectionCancelItem.line_item_id
        )[0].quantity = newQuantity;

        return allocatedDeviceProtectionItemsCopy.reduce((prev, current) => {
            return parseInt(prev) + parseInt(current.quantity);
        }, 0);
    }

    getAvailableDeviceProtectionCancelItems(referenceItem) {
        return this.state.itemsAvailableForCancellation.filter(
            itemAvailableForCancellation =>
                isDeviceProtectionSku(itemAvailableForCancellation.sku) &&
                this.getDeviceProtectionReferenceVariantId(itemAvailableForCancellation) === referenceItem.variant_id.toString()
        );
    }

    getTotalAllocatedDeviceProtectionCancelItemsQuantity(allocatedDeviceProtectionItems) {
        return allocatedDeviceProtectionItems.reduce((prev, current) => {
            return parseInt(prev) + parseInt(current.quantity);
        }, 0);
    }

    handleCancelItemQuantityChangeByValue(lineItem, newValue) {
        if (!this.props.cancelOrderCalculating && !this.props.loading && !isNaN(newValue) && Number(newValue) >= 0) {
            let allocatedCancelItems = JSON.parse(JSON.stringify(this.state.allocatedCancelItems));
            let allocatedCancelItem = this.getAllocatedCancelItem(lineItem, allocatedCancelItems);

            // if item is already in the refund items list
            if (allocatedCancelItem) {
                if (Number(newValue) === 0) {
                    // only remove item from the refund items list if there are no reference items
                    if (isDeviceProtectionSku(lineItem.sku)) {
                        let allocatedReferenceCancelItem = this.getAllocatedReferenceItemByDeviceProtectionItem(lineItem);

                        if (allocatedReferenceCancelItem) {
                            let referenceItem = this.getAvailableForCancellationItem(allocatedReferenceCancelItem);

                            let thresholdQuantity = this.getThresholdQuantity(referenceItem);

                            let allocatedDeviceProtectionCancelItems = this.getAllocatedDeviceProtectionCancelItems(referenceItem, allocatedCancelItems);

                            let totalAllocatedDeviceProtectionCancelItemsQuantityAfterUpdate =
                                this.getTotalAllocatedDeviceProtectionCancelItemsQuantityAfterUpdate(
                                    allocatedDeviceProtectionCancelItems,
                                    allocatedCancelItem,
                                    Number(newValue)
                                );

                            if (totalAllocatedDeviceProtectionCancelItemsQuantityAfterUpdate >= allocatedReferenceCancelItem.quantity - thresholdQuantity) {
                                //remove
                                allocatedCancelItems = this.getUpdatedAllocatedCancelItemsAfterRemovingItem(allocatedCancelItems, lineItem);
                            }
                        } else {
                            //remove
                            allocatedCancelItems = this.getUpdatedAllocatedCancelItemsAfterRemovingItem(allocatedCancelItems, lineItem);
                        }
                    } else {
                        //remove
                        allocatedCancelItems = this.getUpdatedAllocatedCancelItemsAfterRemovingItem(allocatedCancelItems, lineItem);
                    }
                } else {
                    if (isDeviceProtectionSku(lineItem.sku)) {
                        let allocatedReferenceCancelItem = this.getAllocatedReferenceItemByDeviceProtectionItem(lineItem);

                        if (allocatedReferenceCancelItem) {
                            let referenceItem = this.getAvailableForCancellationItem(allocatedReferenceCancelItem);

                            let allocatedDeviceProtectionCancelItems = this.getAllocatedDeviceProtectionCancelItemsByReferenceCancelItem(
                                referenceItem,
                                allocatedCancelItems
                            );

                            let thresholdQuantity = this.getThresholdQuantity(referenceItem);

                            let totalAllocatedDeviceProtectionCancelItemsQuantityAfterUpdate =
                                this.getTotalAllocatedDeviceProtectionCancelItemsQuantityAfterUpdate(
                                    allocatedDeviceProtectionCancelItems,
                                    allocatedCancelItem,
                                    Number(newValue)
                                );

                            if (totalAllocatedDeviceProtectionCancelItemsQuantityAfterUpdate >= allocatedReferenceCancelItem.quantity - thresholdQuantity) {
                                // update quantity
                                allocatedCancelItem.quantity =
                                    Number(newValue) < lineItem.fulfillable_quantity ? Number(newValue) : lineItem.fulfillable_quantity;
                            }
                        } else {
                            // update quantity
                            allocatedCancelItem.quantity = Number(newValue) < lineItem.fulfillable_quantity ? Number(newValue) : lineItem.fulfillable_quantity;
                        }
                    } else {
                        // update quantity
                        allocatedCancelItem.quantity = Number(newValue) < lineItem.fulfillable_quantity ? Number(newValue) : lineItem.fulfillable_quantity;

                        let referenceItem = this.getAvailableForCancellationItem(allocatedCancelItem);
                        let availableDeviceProtectionCancelItems = this.getAvailableDeviceProtectionCancelItems(referenceItem);

                        if (availableDeviceProtectionCancelItems) {
                            let thresholdQuantity = this.getThresholdQuantity(referenceItem);

                            let quantityToAllocate = allocatedCancelItem.quantity - thresholdQuantity;

                            if (quantityToAllocate > 0) {
                                let allocatedDeviceProtectionCancelItems = this.getAllocatedDeviceProtectionCancelItemsByReferenceCancelItem(
                                    lineItem,
                                    allocatedCancelItems
                                );

                                if (allocatedDeviceProtectionCancelItems) {
                                    let totalAllocatedDeviceProtectionCancelItemsQuantity =
                                        this.getTotalAllocatedDeviceProtectionCancelItemsQuantity(allocatedDeviceProtectionCancelItems);

                                    quantityToAllocate = quantityToAllocate - totalAllocatedDeviceProtectionCancelItemsQuantity;

                                    if (quantityToAllocate > 0) {
                                        _.orderBy(allocatedDeviceProtectionCancelItems, ["price"], ["desc"]).forEach(allocatedDeviceProtectionLineItem => {
                                            if (quantityToAllocate === 0) {
                                                return;
                                            }

                                            let avaliableDeviceProtectionCancelItem = this.getAvailableForCancellationItem(allocatedDeviceProtectionLineItem);

                                            if (avaliableDeviceProtectionCancelItem.fulfillable_quantity - allocatedDeviceProtectionLineItem.quantity > 0) {
                                                let maximumQuantityToAdd =
                                                    avaliableDeviceProtectionCancelItem.fulfillable_quantity - allocatedDeviceProtectionLineItem.quantity;
                                                if (maximumQuantityToAdd > 0) {
                                                    let quantityToAdd = maximumQuantityToAdd > quantityToAllocate ? quantityToAllocate : maximumQuantityToAdd;

                                                    allocatedDeviceProtectionLineItem.quantity =
                                                        Number(allocatedDeviceProtectionLineItem.quantity) + Number(quantityToAdd);
                                                    quantityToAllocate = quantityToAllocate - quantityToAdd;
                                                }
                                            }
                                        });
                                    }
                                }

                                if (quantityToAllocate > 0) {
                                    let availableDeviceProtectionCancelItems = this.getAvailableDeviceProtectionCancelItems(referenceItem).filter(
                                        itemAvailableForCancellation =>
                                            !allocatedDeviceProtectionCancelItems.some(li => li.line_item_id === itemAvailableForCancellation.line_item_id) // not already allocated
                                    );

                                    if (availableDeviceProtectionCancelItems) {
                                        _.orderBy(availableDeviceProtectionCancelItems, ["price"], ["desc"]).forEach(availableDeviceProtectionLineItem => {
                                            if (quantityToAllocate === 0) {
                                                return;
                                            }

                                            let deviceProtectionLineItem = this.state.itemsAvailableForCancellation.filter(
                                                i => i.line_item_id === availableDeviceProtectionLineItem.line_item_id
                                            )[0];

                                            let maximumQuantityToAssign = deviceProtectionLineItem.fulfillable_quantity;
                                            let quantityToAssign = maximumQuantityToAssign > quantityToAllocate ? quantityToAllocate : maximumQuantityToAssign;

                                            let newAllocatedCancelItem = {
                                                line_item_id: availableDeviceProtectionLineItem.line_item_id,
                                                quantity: quantityToAssign
                                            };

                                            allocatedCancelItems.push(newAllocatedCancelItem);

                                            quantityToAllocate = quantityToAllocate - quantityToAssign;
                                        });
                                    }
                                }
                            }
                        }
                    }
                }
            } else {
                if (Number(newValue) !== 0) {
                    let newQuantity = newValue < lineItem.fulfillable_quantity ? newValue : lineItem.fulfillable_quantity;

                    let newCancelItem = {
                        line_item_id: lineItem.line_item_id,
                        quantity: newQuantity
                    };

                    // add item to allocated refund items list
                    allocatedCancelItems.push(newCancelItem);

                    if (lineItem.requires_shipping === true) {
                        let deviceProtectionItems = this.getAvailableDeviceProtectionItemsByReferenceItem(lineItem);

                        if (deviceProtectionItems) {
                            let thresholdQuantity = this.getThresholdQuantity(lineItem);

                            if (newQuantity > thresholdQuantity) {
                                let quantityToAllocate = newCancelItem.quantity - thresholdQuantity;

                                if (quantityToAllocate > 0) {
                                    let allocatedDeviceProtectionCancelItems = this.getAllocatedDeviceProtectionCancelItemsByReferenceCancelItem(
                                        lineItem,
                                        allocatedCancelItems
                                    );

                                    if (allocatedDeviceProtectionCancelItems) {
                                        let totalAllocatedDeviceProtectionCancelItemsQuantity =
                                            this.getTotalAllocatedDeviceProtectionCancelItemsQuantity(allocatedDeviceProtectionCancelItems);

                                        quantityToAllocate = quantityToAllocate - totalAllocatedDeviceProtectionCancelItemsQuantity;

                                        if (quantityToAllocate > 0) {
                                            _.orderBy(allocatedDeviceProtectionCancelItems, ["price"], ["desc"]).forEach(allocatedDeviceProtectionLineItem => {
                                                if (quantityToAllocate === 0) {
                                                    return;
                                                }

                                                let avaliableDeviceProtectionCancelItem =
                                                    this.getAvailableForCancellationItem(allocatedDeviceProtectionLineItem);

                                                if (avaliableDeviceProtectionCancelItem.fulfillable_quantity - allocatedDeviceProtectionLineItem.quantity > 0) {
                                                    let maximumQuantityToAdd =
                                                        avaliableDeviceProtectionCancelItem.fulfillable_quantity - allocatedDeviceProtectionLineItem.quantity;
                                                    if (maximumQuantityToAdd > 0) {
                                                        let quantityToAdd =
                                                            maximumQuantityToAdd > quantityToAllocate ? quantityToAllocate : maximumQuantityToAdd;

                                                        allocatedDeviceProtectionLineItem.quantity =
                                                            Number(allocatedDeviceProtectionLineItem.quantity) + Number(quantityToAdd);

                                                        quantityToAllocate = quantityToAllocate - quantityToAdd;
                                                    }
                                                }
                                            });
                                        }
                                    }

                                    if (quantityToAllocate > 0) {
                                        let availableDeviceProtectionCancelItems = this.getAvailableDeviceProtectionCancelItems(lineItem).filter(
                                            itemAvailableForCancellation =>
                                                !allocatedDeviceProtectionCancelItems.some(li => li.line_item_id === itemAvailableForCancellation.line_item_id) // not already allocated
                                        );

                                        if (availableDeviceProtectionCancelItems) {
                                            _.orderBy(availableDeviceProtectionCancelItems, ["price"], ["desc"]).forEach(availableDeviceProtectionLineItem => {
                                                if (quantityToAllocate === 0) {
                                                    return;
                                                }

                                                let deviceProtectionLineItem = this.state.itemsAvailableForCancellation.filter(
                                                    i => i.line_item_id === availableDeviceProtectionLineItem.line_item_id
                                                )[0];

                                                let maximumQuantityToAssign = deviceProtectionLineItem.fulfillable_quantity;
                                                let quantityToAssign =
                                                    maximumQuantityToAssign > quantityToAllocate ? quantityToAllocate : maximumQuantityToAssign;

                                                let newAllocatedCancelItem = {
                                                    line_item_id: availableDeviceProtectionLineItem.line_item_id,
                                                    quantity: quantityToAssign
                                                };

                                                allocatedCancelItems.push(newAllocatedCancelItem);

                                                quantityToAllocate = quantityToAllocate - quantityToAssign;
                                            });
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            this.setState({
                allocatedCancelItems: allocatedCancelItems
            });
        }
    }

    handleChange(e) {
        switch (e.target.name) {
            case "cancel-reason":
                this.setState({
                    cancelReasonId: e.target.value
                });
                break;

            default:
                break;
        }
    }

    resetCancelReason() {
        this.setState({
            cancelReasonId: null
        });
    }

    resetCancelItems() {
        this.setState({
            allocatedCancelItems: []
        });
    }

    handleSelectAllClick() {
        let allocatedCancelItems = [];

        this.state.itemsAvailableForCancellation.forEach(lineItem => {
            allocatedCancelItems.push({
                line_item_id: lineItem.line_item_id,
                quantity: lineItem.fulfillable_quantity
            });
        });

        this.setState({
            allocatedCancelItems: JSON.parse(JSON.stringify(allocatedCancelItems))
        });
    }

    selectAllEnabled() {
        return !this.state.itemsAvailableForCancellation.every(lineItem =>
            this.state.allocatedCancelItems.some(
                cancelItem => lineItem.line_item_id === cancelItem.line_item_id && lineItem.fulfillable_quantity === cancelItem.quantity
            )
        );
    }

    handleCloseConfirmationWindow() {
        this.setState({
            confirmationWindowOpen: false
        });
    }

    handleOpenConfirmationWindow() {
        this.setState({
            confirmationWindowOpen: true
        });
    }

    handleRefreshOrder() {
        this.props.handleClose();
        this.props.refreshOrder();
    }

    getFilterDeviceProtectionLineItemName(deviceProtectionLineItem) {
        let firstPart = deviceProtectionLineItem.name.slice(0, deviceProtectionLineItem.name.indexOf("-"));
        let secondPart = "";

        const protectedVariantId = this.getDeviceProtectionReferenceVariantId(deviceProtectionLineItem);

        if (protectedVariantId) {
            let referenceItem = this.props.order.line_items.filter(li => li.requires_shipping === true && li.variant_id.toString() === protectedVariantId)[0];

            secondPart = referenceItem ? referenceItem.name : "";
        }

        return `${firstPart} - ${secondPart}`;
    }

    handleCancelItemRemoveEnabled(lineItem) {
        return this.state.allocatedCancelItems.filter(i => i.line_item_id === lineItem.line_item_id)[0];
    }

    handleCancelItemAddEnabled(lineItem) {
        return !(
            this.state.allocatedCancelItems.filter(i => i.line_item_id === lineItem.line_item_id)[0] &&
            this.state.allocatedCancelItems.filter(i => i.line_item_id === lineItem.line_item_id)[0].quantity === lineItem.fulfillable_quantity
        );
    }

    getCanceItemSelectedQuantity(lineItem) {
        return this.state.allocatedCancelItems.filter(i => i.line_item_id === lineItem.line_item_id)[0]
            ? this.state.allocatedCancelItems.filter(i => i.line_item_id === lineItem.line_item_id)[0].quantity
            : 0;
    }

    getMinimumRequiredDeviceProtectionQuantity(deviceProtectionItem) {
        const protectedVariantId = this.getDeviceProtectionReferenceVariantId(deviceProtectionItem);
        if (!protectedVariantId) return 0;

        const referenceDevice = this.state.itemsAvailableForCancellation.find(
            item => item.requires_shipping === true && item.variant_id.toString() === protectedVariantId
        );
        if (!referenceDevice) return 0;

        const allocatedReferenceDevice = this.state.allocatedCancelItems.find(item => item.line_item_id === referenceDevice.line_item_id);
        if (!allocatedReferenceDevice) return 0;

        return allocatedReferenceDevice.quantity;
    }

    isDeviceProtectionQuantityLocked(deviceProtectionItem) {
        const minimumRequired = this.getMinimumRequiredDeviceProtectionQuantity(deviceProtectionItem);
        return minimumRequired > 0 && minimumRequired === deviceProtectionItem.fulfillable_quantity;
    }

    sortItems(items) {
        let sortedItems = [];

        let itemsCopy = JSON.parse(JSON.stringify(items));

        itemsCopy.forEach(item => {
            item.price = parseFloat(item.price);
        });

        itemsCopy = _.orderBy(itemsCopy, ["price", "sku"], ["desc", "asc"]);

        itemsCopy.forEach(item => {
            if (item.requires_shipping === true) {
                sortedItems.push(item);

                let deviceProtectionItems = itemsCopy.filter(
                    i => isDeviceProtectionSku(i.sku) && this.getDeviceProtectionReferenceVariantId(i) === item.variant_id.toString()
                );

                if (deviceProtectionItems) {
                    sortedItems = sortedItems.concat(deviceProtectionItems);
                }
            }
        });

        // Add any remaining device protection items that weren't linked to a reference item
        const unlinkedDeviceProtectionItems = itemsCopy.filter(i => isDeviceProtectionSku(i.sku) && !sortedItems.some(si => si.id === i.id));
        sortedItems = sortedItems.concat(unlinkedDeviceProtectionItems);

        return sortedItems;
    }

    sortModifiedItems(items) {
        let normalSortedList = this.sortItems(this.props.order.line_items);
        let sortedItems = [];
        let itemsCopy = JSON.parse(JSON.stringify(items));
        itemsCopy.forEach(item => {
            item.price = parseFloat(item.price);
        });

        normalSortedList.forEach(normalSorteditem => {
            var item = items.filter(i => i.id === normalSorteditem.id)[0];
            if (item) {
                sortedItems.push(item);
            }
        });

        // Add any items that weren't in the normal sorted list (shouldn't happen, but safety check)
        items.forEach(item => {
            if (!sortedItems.some(si => si.id === item.id)) {
                sortedItems.push(item);
            }
        });

        return sortedItems;
    }

    render() {
        const { name, preorder } = this.props.order;

        const {
            total_line_items_price_formatted,
            total_discounts_formatted,
            total_shipping_formatted,
            total_tax_formatted,
            total_shipping_protection_formatted,
            total_price_formatted
        } = this.props.cancelOrderCalculateData;

        const {
            ORDER_PAGE: {
                CANCEL_SECTION: { REFUND_SUMMARY, CANCEL_ORDER_ITEMS, REASON_HEADER, REASONS }
            },
            DATA_CONFLICT,
            MISC
        } = this.props.currentLanguage;

        return (
            <Dialog
                classes={{ paper: `popup-window-dialog-paper${this.state.cancelFinished ? " completed" : ""}` }}
                className="popup-window-dialog"
                disableBackdropClick
                disableEscapeKeyDown
                open={this.props.open || false}
                onEnter={this.handleEnter.bind(this)}
            >
                <div
                    id="popup-window"
                    className={`layout vertical popup-window cancel-order-items-window relative${this.state.cancelFinished ? " completed" : ""}`}
                >
                    <div className="flex layout horizontal end-justified">
                        <CloseIcon className="layout vertical center-center close-corner-button" onClick={this.handleNoClick.bind(this)} />
                    </div>
                    <div className="flex layout vertical popup-window-inner">
                        {(this.state.confirmationWindowOpen || this.state.dataConflictWindowOpen) && <div className="fit layout vertical backdrop-1" />}
                        {(this.props.loading || this.props.cancelOrderCalculating || this.props.cancelReasonsLoading) && (
                            <div className={`loading-box fit layout vertical center-center`}>
                                <CircularProgress className="loading-progress" size={74} color="primary" thickness={6} />
                            </div>
                        )}
                        <div className="layout vertical header">
                            <p className="layout vertical center-center title">{CANCEL_ORDER_ITEMS.HEADING}</p>
                        </div>
                        {!this.state.cancelFinished && (
                            <React.Fragment>
                                <div className="layout vertical body">
                                    {this.props.total_egift_cards !== null && this.props.total_egift_cards > 0 && (
                                        <div className="egiftcards-notice">{CANCEL_ORDER_ITEMS.EGIFTCARDS_PRESENT_MESSAGE}</div>
                                    )}
                                    <p style={{ margin: "0px 0px 5px" }}>{CANCEL_ORDER_ITEMS.SUBHEADING}</p>
                                    <div className="flex layout dynamic-direction-mobile-landspace">
                                        <div className="flex layout vertical cancel-items-box">
                                            {this.sortModifiedItems(this.state.itemsAvailableForCancellation).map((li, i) => {
                                                const isDeviceProtection = isDeviceProtectionSku(li.sku);
                                                const minimumRequired = isDeviceProtection ? this.getMinimumRequiredDeviceProtectionQuantity(li) : 0;
                                                const isLocked = isDeviceProtection && this.isDeviceProtectionQuantityLocked(li);

                                                let availableQuantitySelectList = [];
                                                const startIndex = isDeviceProtection ? minimumRequired : 0;
                                                for (let index = startIndex; index <= li.fulfillable_quantity; index++) {
                                                    availableQuantitySelectList.push(index);
                                                }

                                                const variantName = getFilteredLineItemVariant(li);
                                                const productName = getFilteredLineItemName(li, this.props.order);

                                                return (
                                                    <div key={i} className="layout horizontal list-item">
                                                        <div className="flex layout horizontal list-item-name-box center">
                                                            <div className="flex list-item-image-box relative">
                                                                <img
                                                                    className="list-item-image"
                                                                    src={getItemPicture(li.sku)}
                                                                    alt=""
                                                                    onError={e => (e.target.src = getFallbackItemPicture())}
                                                                />
                                                            </div>
                                                            <div className="layout vertical">
                                                                <span className="line-item-title">{productName}</span>
                                                                {!isDeviceProtection && variantName && (
                                                                    <span className="line-item-variant-name">{variantName}</span>
                                                                )}
                                                                <span>{li.price_formatted || li.price}</span>
                                                            </div>
                                                        </div>
                                                        <div className="layout horizontal center list-item-quantity-box">
                                                            <Select
                                                                classes={{
                                                                    selectMenu: "custom-select-menu",
                                                                    disabled: "custom-select-disabled"
                                                                }}
                                                                name="cancel-item-quantity"
                                                                MenuProps={{
                                                                    variant: "menu",
                                                                    getContentAnchorEl: null,
                                                                    classes: {
                                                                        paper: "custom-select-menu-paper"
                                                                    }
                                                                }}
                                                                className="custom-select"
                                                                style={{
                                                                    minWidth: "50px",
                                                                    opacity: isLocked ? 0.6 : 1,
                                                                    cursor: isLocked ? "not-allowed" : "pointer"
                                                                }}
                                                                disabled={isLocked}
                                                                value={this.getCanceItemSelectedQuantity(li)}
                                                                onChange={this.handleCancelItemQuantityChange.bind(this, li)}
                                                            >
                                                                {availableQuantitySelectList.map((selectQuantity, i) => {
                                                                    return (
                                                                        <MenuItem key={i} className="form-menu-item-select-multiple" value={selectQuantity}>
                                                                            <ListItemText
                                                                                classes={{
                                                                                    root: "form-menu-item-select-multiple-list-item-text"
                                                                                }}
                                                                            >
                                                                                {selectQuantity}
                                                                            </ListItemText>
                                                                        </MenuItem>
                                                                    );
                                                                })}
                                                            </Select>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                        <div className="flex layout vertical">
                                            <div className="order-summary-container allow-focus">
                                                <h2 className="container-title">{REFUND_SUMMARY.HEADING}</h2>
                                                <div className="layout horizontal">
                                                    <div>{name}</div>
                                                    <div className="layout horizontal order-tags">{preorder && <div className="tag">{MISC.PREORDER}</div>}</div>
                                                </div>
                                                <div className="summary-divider"></div>
                                                <div className="summary-line-container">
                                                    <div className="summary-line-label">{`${REFUND_SUMMARY.ITEMS_SUBTOTAL_TITLE}:`}</div>
                                                    <div className="summary-line-value">{total_line_items_price_formatted || "-"}</div>
                                                </div>
                                                {this.props.cancelOrderCalculateData && this.props.cancelOrderCalculateData.total_discounts > 0 && (
                                                    <div className="summary-line-container">
                                                        <div className="summary-line-label">{`${REFUND_SUMMARY.DISCOUNT_TITLE}:`}</div>
                                                        <div className="summary-line-value">{total_discounts_formatted || "-"}</div>
                                                    </div>
                                                )}
                                                <div className="summary-line-container">
                                                    <div className="summary-line-label">{`${REFUND_SUMMARY.SHIPPING_TITLE}:`}</div>
                                                    <div className="summary-line-value">{total_shipping_formatted || "-"}</div>
                                                </div>
                                                <div className="summary-line-container">
                                                    <div className="summary-line-label">{`${REFUND_SUMMARY.TAXES_TITLE}:`}</div>
                                                    <div className="summary-line-value">{total_tax_formatted || "-"}</div>
                                                </div>
                                                {orderHasShippingProtection(this.props.order) && (
                                                    <div className="summary-line-container">
                                                        <div className="summary-line-label">{`${REFUND_SUMMARY.SHIPPING_PROTECTION_TITLE}:`}</div>
                                                        <div className="summary-line-value">{total_shipping_protection_formatted || "-"}</div>
                                                    </div>
                                                )}
                                                <div className="summary-divider"></div>
                                                <div className="summary-line-container">
                                                    <div className="summary-line-label total">{`${REFUND_SUMMARY.REFUND_TOTAL_TITLE}:`}</div>
                                                    <div className="summary-line-value total">
                                                        <p className="total-price">{total_price_formatted || "-"}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="cancel-reason-box">
                                                <div className="layout vertical custom-select-box">
                                                    <InputLabel className={`custom-select-label`}>{`*${REASON_HEADER}`}</InputLabel>
                                                    <Select
                                                        classes={{
                                                            selectMenu: "custom-select-menu"
                                                        }}
                                                        name="cancel-reason"
                                                        MenuProps={{
                                                            variant: "menu",
                                                            getContentAnchorEl: null,
                                                            classes: {
                                                                paper: "custom-select-menu-paper"
                                                            }
                                                        }}
                                                        className="custom-select"
                                                        disabled={false}
                                                        value={this.state.cancelReasonId || -1}
                                                        onChange={this.handleChange.bind(this)}
                                                    >
                                                        {this.props.cancelReasons &&
                                                            this.props.cancelReasons.length > 0 &&
                                                            this.props.cancelReasons.map((cancelReason, i) => {
                                                                return (
                                                                    <MenuItem key={i} className="form-menu-item-select-multiple" value={cancelReason.id}>
                                                                        <ListItemText
                                                                            classes={{
                                                                                root: "form-menu-item-select-multiple-list-item-text"
                                                                            }}
                                                                        >
                                                                            {REASONS[cancelReason.code]}
                                                                        </ListItemText>
                                                                    </MenuItem>
                                                                );
                                                            })}
                                                        )
                                                    </Select>
                                                    {this.state.submitErrors.length > 0 && this.state.submitErrors.find(e => e.code === "cancel_reason") && (
                                                        <FormHelperText>{this.state.submitErrors.find(e => e.code === "cancel_reason").label}</FormHelperText>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="layout vertical footer">
                                    {this.state.cancelErrorMessage && <div className="message-box">{this.state.cancelErrorMessage}</div>}
                                    <div className="layout vertical buttons-box">
                                        <div className="flex layout dynamic-direction-mobile-portrait buttons">
                                            <button className="flex custom-button negative" onClick={this.handleNoClick.bind(this)}>
                                                <div className="layout vertical center-center inbutton-text">{MISC.CLOSE}</div>
                                            </button>
                                            <button
                                                className={`flex custom-button ${this.props.loading ? "loading" : ""}`}
                                                style={{ float: "right" }}
                                                onClick={this.props.loading ? null : this.handleYesClick.bind(this)}
                                            >
                                                <div className="layout vertical center-center inbutton-text">{MISC.SUBMIT}</div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </React.Fragment>
                        )}
                        {this.state.cancelFinished && (
                            <React.Fragment>
                                <div className="layout vertical body">
                                    <div className="flex layout horizontal center-center">
                                        <Confirmed fill="#BF0000" />
                                        <p style={{ margin: "0px 10px" }}>
                                            {this.props.cancelOrderCalculateData && this.props.cancelOrderCalculateData.full_order_refund
                                                ? CANCEL_ORDER_ITEMS.SUCCESS_MESSAGE_FULL_ORDER
                                                : CANCEL_ORDER_ITEMS.SUCCESS_MESSAGE}
                                        </p>
                                    </div>
                                </div>
                                <div className="layout vertical footer">
                                    <div className="flex layout dynamic-direction-mobile-portrait buttons">
                                        <button className="flex custom-button" onClick={this.handleNoClick.bind(this)}>
                                            <div className="layout vertical center-center inbutton-text">{MISC.CLOSE}</div>
                                        </button>
                                    </div>
                                </div>
                            </React.Fragment>
                        )}
                        <ConfirmationWindow
                            open={this.state.confirmationWindowOpen}
                            handleClose={this.handleCloseConfirmationWindow.bind(this)}
                            handleSubmit={this.handleConfirmCancelOrder.bind(this)}
                            loading={this.props.loading}
                            heading={CANCEL_ORDER_ITEMS.CONFIRMATION.HEADING}
                            subheading={
                                this.props.cancelOrderCalculateData && this.props.cancelOrderCalculateData.full_order_refund
                                    ? CANCEL_ORDER_ITEMS.CONFIRMATION.SUBHEADING_CANCEL_FULL_ORDER
                                    : CANCEL_ORDER_ITEMS.CONFIRMATION.SUBHEADING_CANCEL_ITEMS
                            }
                            noText={MISC.NO}
                            yesText={MISC.YES}
                        />
                        <DataConflictWindow
                            open={this.state.dataConflictWindowOpen}
                            handleSubmit={this.handleRefreshOrder.bind(this)}
                            heading={DATA_CONFLICT.HEADING}
                            subheading={DATA_CONFLICT.SUB_HEADING}
                            yesText={MISC.REFRESH}
                        />
                    </div>
                </div>
            </Dialog>
        );
    }
}

export default withRouter(CancelOrderItemsWindow);
